/**
 * This module just holds text constants, one day it may be replaced by some i18n lib
 *
 * i18n                      .concierge = 'Concierge'
 * i18n.plural               .concierge = 'Concierges'
 * i18n.withIndefiniteArticle.concierge = 'a Concierge'
 */
const i18nTable = {
  concierge: 'Concierge',
  healthConcierge: 'Health Concierge',
};

const transformations = {
  plural: (value: string) => `${value}s`,
  withIndefiniteArticle: (value: string) => `${indefiniteArticleOf(value)} ${value}`,
};

type I18n = typeof i18nTable & {
  [K in keyof typeof transformations]: typeof i18nTable;
};

// extends i18nTable with new functions, ie.
// i18n.withIndefiniteArticle.concierge = 'a Concierge'

const i18n = new Proxy(i18nTable, {
  get(target, prop, receiver) {
    const tranformation = transformations[prop as keyof typeof transformations];
    if (tranformation) {
      return makeTransformerProxy(i18nTable, tranformation);
    }
    //@ts-ignore
    return Reflect.get(...arguments);
  },
}) as I18n;

function makeTransformerProxy(value: any, callback: (val: string) => string) {
  return new Proxy(value, {
    get() {
      //@ts-ignore
      return callback(Reflect.get(...arguments));
    },
  });
}

function indefiniteArticleOf(s: string) {
  if (s.match(/[aeiou].*/) === null) {
    return 'an';
  }
  return 'a';
}

export default i18n;
